import React, { Component } from 'react';

import { SettingsContextChild } from '../settings-runtime';

export default class extends Component {
  render() {
    const {
      settingsKey,
      children
    } = this.props;

    return (
      <SettingsContextChild>
        {({ settings, settingsStorage }) => {
          const onChange = (value) => {
            if (settingsKey) {
              settingsStorage.setItem(settingsKey, value);
            }
          };

          return children({
            value: settings[settingsKey],
            onChange
          });
        }}
      </SettingsContextChild>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/managed-component.js